import HeaderAboutUs from './Headers/HeaderAboutUs.js';
import '../styles/AboutUs.scss';
import FooterAboutUs from './Footers/FooterAboutUs.js';
import { faBowlFood, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import ceo from '../images/ceo.png';
import chef1 from '../images/chef1.png';
import chef2 from '../images/chef2.png';
import chef3 from '../images/chef3.png';
import { faFacebookF, faInstagram, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

function AboutUs() {
    return (
        <div className = "AboutUs">
            <HeaderAboutUs/> 

                <div id = "aboutUsHeaderImg">
                    <span>About Us</span>
                </div>

                <div id = "ceoAndAdvantages">
                    <div id = "ceo">
                        <button>100%</button>
                        <span>Premium Quality Service</span>
                        <span>Founder & Head Chef</span>
                            <div id = "orangeBackground">
                                <img src = {ceo}/>
                            </div>
                    </div>
            
                <div id = "advantages">
                    <div id = "cookingIcon">
                        <FontAwesomeIcon icon= {faBowlFood} />
                    </div>
                        <div id = "deliciousFood" className = "advantages">Fresh Ingredients</div>
                        <div id = "area" className = "advantages">Top Rated Restaurant</div>
                        <div id = "skilledChefs" className = "advantages">Proffesional Chefs</div>
                        <div id = "stars" className = "advantages">Loved by Customers</div>
                </div>
                </div>

                <div id = "whyTheBest">
                    <div id = "aboutUsSpan">About Us</div>
                        <span id="whyTheBestSpan">Why Customers Choose Us</span>
                        <p id="whyTheBestParagraph">
                        We focus on quality, taste and customer experience.
                        Every dish is prepared with fresh ingredients and attention to detail,
                        so you can enjoy food that truly stands out.
                        </p>
                            <div id = "healthyFood" className = "quickAndHealthy">
                            <div id = "healthyFoodIcon">
                                <FontAwesomeIcon icon = {faUtensils}/>
                            </div>
                        <span>Fresh & Healthy Meals</span>
                        <p>We use carefully selected ingredients to create meals that are both delicious and good for you</p>   
                            </div>
                    <div id = "quickDelivery" className = "quickAndHealthy">
                        <div id = "quickDeliveryIcon">
                            <FontAwesomeIcon icon = {faPaperPlane} />
                        </div>
                            <span>Fast Delivery</span>
                            <p>Hot, fresh and delivered quickly so you never have to wait too long</p>
                    </div>    
                </div> 

                <div id = "kitchenExpertsParagraph">
                    <span>Meet Our Chefs</span>
                    <p>Our team of passionate chefs brings experience, creativity and love for food into every dish</p> 
                </div>

                <div id = "kitchenExperts">
                    <div className = "kitchenExperts">
                        <img src  = {chef1}></img>
                        <span>Michael Carter</span>
                        <span>Head Chef</span>
                            <div id = "socialMediaChefs">
                                <FontAwesomeIcon icon = {faFacebookF} className = "fb"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faInstagram} className = "insta"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faTwitter} className = "twitter"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faYoutube} className = "yt"/>
                            </div>
                    </div>

                    <div className = "kitchenExperts">
                        <img src = {chef2}></img>
                        <span>Daniel Lee</span>
                        <span>Pastry Chef</span>
                            <div id = "socialMediaChefs">
                                <FontAwesomeIcon icon = {faFacebookF} className = "fb"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faInstagram} className = "insta"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faTwitter} className = "twitter"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faYoutube} className = "yt"/>
                            </div>
                    </div>

                    <div className = "kitchenExperts">
                        <img src = {chef3}></img>
                        <span>Sophia Martinez</span>
                        <span>Sous Chef</span>
                            <div id = "socialMediaChefs">
                                <FontAwesomeIcon icon = {faFacebookF} className = "fb"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faInstagram} className = "insta"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faTwitter} className = "twitter"/>
                                    <hr></hr>
                                <FontAwesomeIcon icon = {faYoutube} className = "yt"/>
                            </div>
                    </div>     
                </div> 
                <FooterAboutUs/>
        </div>  
    )
}
export default AboutUs;